<template>
  <div style='max-width:800px; margin: 0 auto' class="tag-partner">
    <div>
      <div @click="show = true" class="link-detail link-big-detail">
        <b>{{ $t("components.payment.pellegrini_link") }}</b>
      </div>
      <div v-if="show">
        <div class="flex input-area mt-5">
          <input
              type='text'
              class='form-control'
              placeholder='Codice'
              v-model="otp"
              maxlength="7"
          >

           <CTA
              type="submit"
              :content="$t('buttons.apply')"
              :size="`small`"
              :loading="loading"
              @click="pay"
          />
        </div>

        <flash
            :flash="flash"
            :state="state"
        />
        <p>Inserisci qui il codice che hai generato nell'app per utilizzare i buoni pasto Pellegrini.</p>
        <p>Vedrai i tuoi buoni pasto applicati sotto forma di sconto.</p>
      </div>
    </div>
  </div>
</template>

<script>

import { PellegriniApi } from '../../api/PellegriniApi'
import { orderStore } from '../../store/orderStore'
import { Order } from '../../core/Order'
import Flash from '../Parts/Flash'

export default {
  components: {
    Flash
  },

  data () {
    return {
      show: false,
      loading: false,
      otp: null,
      flash: null,
      state: null
    }
  },

  computed: {
    user () {
      return this.$root.user
    },
    order () {
      return this.user.order
    },
  },

  methods: {
    pay () {
      this.state = null;
      this.flash = ''

      this.loading = true

      var token = this.user.order.token
      var em = new PellegriniApi()
      return em.pay(token, this.otp)

      .then(response => {
        var user = this.user
        
        if (user) user.order = response.body.data.resource
    
        this.$root.updateUser(user)

        this.loading = false

        this.state = "success";
        this.flash = "Aggiunto correttamente!"
      }).finally(() => {
        this.loadOrder()
      })

      .catch(response => {

        this.loading = false
        this.state = "error"

        if (response.status === 400) {

          this.flash = this.$t(response.body.message)
        }
      })
    },

    loadOrder () {
      if (!this.user.order) return 
      orderStore.state.order = new Order(this.user.order)
    },
  },
}

</script>

<style scoped>

.input-area {
    max-width: 240px;
}
</style>